export const BRL = (n) =>
  Number(n || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const CHART_COLORS = ["#003D75", "#A65F76", "#0A5AA8", "#C1859A", "#2C6FB0", "#7E3F54", "#5B8FC7"];

export function ScopeToggle({ scope, setScope }) {
  return (
    <div className="inline-flex rounded-full border border-border bg-surface p-1 shadow-sm" data-testid="scope-toggle">
      {[["personal", "Pessoal"], ["business", "Empresarial"]].map(([v, l]) => (
        <button key={v} data-testid={`scope-${v}`} onClick={() => setScope(v)}
          className={`px-4 py-1.5 rounded-full text-sm font-body transition-colors ${
            scope === v ? "bg-primary text-white shadow" : "text-text-secondary hover:bg-muted"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
